import { useEffect, useState } from "react"
import { Modal, ModalId, useUIState } from "../../../../../features/ui"
import { SalePaymentItemForm } from "./salePaymentItemForm"
import { PaymentType } from "../../../../administration"
import { SalePaymentItemData } from "../../../services/sale-operation-service/types"

type Props = {
    salePaymentItem?: SalePaymentItemData
    paymentTypes: PaymentType[]
    defaultPaymentTypeId?: string
    defaultAmount?: number
    defaultAmounts?: Map<string, number>
    defaultCheckName?: string
    maxAmount?: number
    hideAdjustments?: boolean
    roundingMode?: boolean
    onSubmit: (salePaymentItem: Partial<SalePaymentItemData>) => void
}

export const SalePaymentItemFormModal = (props: Props) => {
    const { salePaymentItem, paymentTypes, defaultPaymentTypeId, defaultAmount, defaultAmounts, defaultCheckName, maxAmount, hideAdjustments, roundingMode, onSubmit } = props

    const [key, setKey] = useState(0)
    const { openedModal } = useUIState()

    useEffect(() => setKey(key + 1), [openedModal])

    const title = roundingMode ? 'Editar Redondeo' : 'Agregar Medio de Pago'

    return (
        <Modal
            modalId={ModalId.SALE_PAYMENT_ITEM_FORM}
            title={title}
            actions={[]}
            widthSize="m"
        >
            <SalePaymentItemForm
                key={key}
                salePaymentItem={salePaymentItem}
                paymentTypes={paymentTypes}
                defaultPaymentTypeId={defaultPaymentTypeId}
                defaultAmount={defaultAmount}
                defaultAmounts={defaultAmounts}
                defaultCheckName={defaultCheckName}
                maxAmount={maxAmount}
                hideAdjustments={hideAdjustments}
                roundingMode={roundingMode}
                onSubmit={onSubmit}
            />
        </Modal>
    )
}
